import { create } from 'zustand';
import { ArchiveIndexMemberData, MemberSearchData } from '../dto/EntityRepository';

/**
 * API·검색 모두 비었을 때만 쓰는 표시용 폴백. 스토어 초기값이 아님 — 서버가 `[]`를 주면 그대로 반영한 뒤,
 * “보여줄 목록”이 빌 때만 selector에서 이 배열을 씀 (`aui` 없으면 클릭 이동 없음).
 */
export const DEFAULT_LANDING_ARCHIVE_FALLBACK: ArchiveIndexMemberData[] = [
  { handle: 'architrave_official', username: 'Architrave', aui: 'df89a3db' },
];

/**
 * 테스트·목업용 더미. `aui` 비움 → 랜딩에서 항목은 보이나 아카이브 클릭 이동 없음.
 * 의도적으로 같은 영문 알파벳·같은 한글 초성으로 묶여 랜딩 그룹 헤더가 적게 나오게 함.
 */
export const LANDING_MEMBER_DUMMY_DATA: ArchiveIndexMemberData[] = [
  // { handle: 'dummy_a1', username: 'Alpha Studio', aui: '' },
  // { handle: 'dummy_a2', username: 'Amber Lane', aui: '' },
  // { handle: 'dummy_a3', username: 'Atlas Lab', aui: '' },
  // { handle: 'dummy_a4', username: 'Arc Atelier', aui: '' },

  // { handle: 'dummy_a5', username: 'April Room', aui: '' },
  // { handle: 'dummy_a6', username: 'Avenue Works', aui: '' },
  // { handle: 'dummy_b1', username: 'Beta Works', aui: '' },
  // { handle: 'dummy_b2', username: 'Blue Ocean', aui: '' },
  // { handle: 'dummy_b3', username: 'Bloom Art', aui: '' },
  // { handle: 'dummy_b4', username: 'Bridge Studio', aui: '' },
  // { handle: 'dummy_b5', username: 'Byte Lab', aui: '' },
  // { handle: 'dummy_g1', username: '김작가', aui: '' },
  // { handle: 'dummy_g2', username: '김민수', aui: '' },
  // { handle: 'dummy_g3', username: '김서연', aui: '' },

  // { handle: 'dummy_g4', username: '기획 연구소', aui: '' },
  // { handle: 'dummy_g5', username: '강호 스튜디오', aui: '' },
  // { handle: 'dummy_n1', username: '노을 작업실', aui: '' },
  // { handle: 'dummy_n2', username: '나무 워크스', aui: '' },
  // { handle: 'dummy_hash1', username: '3D Lab', aui: '' },
  // { handle: 'dummy_hash2', username: '99 Percent', aui: '' },
];

/** 랜딩: Archive Index API 목록 + 검색 결과(표시 시 검색 행이 앞·아카이브는 유지·중복 제거) */
interface LandingMemberState {
  archiveIndexList: ArchiveIndexMemberData[];
  searchList: MemberSearchData[];
  setArchiveIndexList: (value: ArchiveIndexMemberData[]) => void;
  setSearchList: (value: MemberSearchData[]) => void;
  clearSearchList: () => void;
}

export const useLandingMemberStore = create<LandingMemberState>((set) => ({
  archiveIndexList: [],
  // archiveIndexList: [...LANDING_MEMBER_DUMMY_DATA],
  searchList: [],
  setArchiveIndexList: (archiveIndexList) => set({ archiveIndexList }),
  setSearchList: (searchList) => set({ searchList }),
  clearSearchList: () => set({ searchList: [] }),
}));

const displayMemberKey = (m: MemberSearchData): string => {
  const aui = m.aui?.trim();
  if (aui) return `aui:${aui}`;
  const handle = m.handle?.trim().toLowerCase();
  if (handle) return `handle:${handle}`;
  return `name:${m.username}`;
};

/**
 * 표시 순서: 검색 결과 전체(앞) + 아카이브 인덱스 중 검색과 동일 인물 제외(뒤).
 * 검색이 비면 아카이브만. 둘 다 비면 `DEFAULT_LANDING_ARCHIVE_FALLBACK`.
 */
export const selectLandingMemberDisplayList = (s: LandingMemberState): ArchiveIndexMemberData[] => {
  const { searchList, archiveIndexList } = s;

  if (searchList.length === 0) {
    return archiveIndexList.length > 0 ? archiveIndexList : DEFAULT_LANDING_ARCHIVE_FALLBACK;
  }

  const searchKeys = new Set(searchList.map(displayMemberKey));
  const archiveRest = archiveIndexList.filter((m) => !searchKeys.has(displayMemberKey(m)));
  const merged = [...searchList, ...archiveRest];

  return merged.length > 0 ? merged : DEFAULT_LANDING_ARCHIVE_FALLBACK;
};
